import { IIncomingOffer } from '../types/business-offer';

export const filterExpiredOffers = (
  offers: IIncomingOffer[] | undefined,
): IIncomingOffer[] => {
  if (!offers || offers.length === 0) {
    return [];
  }

  const now = Date.now();
  return offers.filter((item) => {
    const dateObject = new Date(item.expiration_date);
    const offset = dateObject.getTimezoneOffset();
    const localDate = new Date(dateObject.getTime() - offset * 60000); //Умножение на 60000 преобразует минуты в миллисекунды
    // Сравниваем с текущим временем
    return localDate.getTime() > now;
  });
};
